import { format, isValid, parseISO } from 'date-fns';
import { enUS, ru } from 'date-fns/locale';

import { LangTypeEnum } from '~/modules/lang/types/Lang';

import { i18n } from '../modules/lang/LangAdapter';

export default class DateHelper {
  static getDateFnsLocale = () => {
    switch (i18n.language) {
      case LangTypeEnum.RU:
        return ru;

      default:
        return enUS;
    }
  };

  static format = (date: string | null | undefined, customFormat = 'dd.MM.yyyy'): string | undefined => {
    if (!date || !isValid(parseISO(date))) {
      return;
    }

    return format(parseISO(date), customFormat, {
      locale: DateHelper.getDateFnsLocale(),
    });
  };
}
